'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (username) {
  if (!username) {
    return false;
  }

  var extracted = (0, _extractMentions2.default)(username);

  // Should extract the username minus the @ sign, hence the .slice(1)
  return extracted.length === 1 && extracted[0] === username.slice(1);
};

var _extractMentions = require('./extractMentions');

var _extractMentions2 = _interopRequireDefault(_extractMentions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0

module.exports = exports['default'];